const ignoredInteractiveSelector = 'button, [role="button"], input, textarea, select'

export function getMiddleClickAnchor(event: MouseEvent): HTMLAnchorElement | null {
  const target = event.target
  if(!(target instanceof Element)) {
    return null
  }
  if(target.closest(ignoredInteractiveSelector)) {
    return null
  }
  const anchor = target.closest('a')
  if(!anchor || anchor.hasAttribute('download')) {
    return null
  }
  return anchor
}
